import { render } from "./MetaItem.vue?vue&type=template&id=b1f131f2"
import script from "./MetaItem.vue?vue&type=script&lang=js"
export * from "./MetaItem.vue?vue&type=script&lang=js"

import "./MetaItem.vue?vue&type=style&index=0&id=b1f131f2&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__